import HeadTags from '@/lib/head/HeadTags'

import ChangeInformation from './components/ChangeInformation'
import ChangePassword from './components/ChangePassword'
import RequestDeletion from './components/RequestDeletion'
import style from './Profile.module.scss'

export default memo(function Profile() {
  return (
    <>
      <HeadTags title='Profile' />
      <div className={style.ProfileSection}>
        <h1 className={style.Heading}>Profile</h1>
        <ChangeInformation />
        <ChangePassword />
        <RequestDeletion />
      </div>
    </>
  )
})
